import { OrderItem } from '../../types';
import { getAllOrderItemsTotal } from './getAllOrderItemsTotal';
import { removeLinkedDoorItems } from './removeLinkedDoorItems';

export function getAllOrderItemsExcludingDoorsTotal(orderItems : OrderItem[]) : string {

    return getAllOrderItemsTotal(removeLinkedDoorItems(orderItems));

}